import { DateTime } from 'luxon';
import { supportedDateFormats } from '../../../../Components/TzDate/utils';

export const ACTION_LOG_REPORT_ENTITY_CHOICES = [
  { id: 'offers', name: 'Offers' },
  { id: 'products', name: 'Products' },
  { id: 'mapping_rules', name: 'Mapping Rules' },
] as const;

export const ACTION_LOG_REPORT_ACTION_CHOICES = [
  { id: 'create', name: 'Added' },
  { id: 'update', name: 'Changed' },
  { id: 'delete', name: 'Removed' },
] as const;

const attributeChoicesByEntityType: Record<string, readonly { id: string; name: string }[]> = {
  offers: [
    { id: 'category', name: 'Category' },
    { id: 'product', name: 'Product' },
    { id: 'manufacturer', name: 'Manufacturer' },
    { id: 'is_approved', name: 'Approved' },
    { id: 'is_adult', name: 'Adult' },
  ],
  products: [
    { id: 'name', name: 'Name' },
    { id: 'category', name: 'Category' },
    { id: 'manufacturer', name: 'Manufacturer' },
    { id: 'model', name: 'Model' },
    { id: 'description', name: 'Description' },
  ],
  mapping_rules: [
    { id: 'category', name: 'Category' },
    { id: 'external_category', name: 'External Category' },
    { id: 'ignored', name: 'Ignore New Offers Matching Rule In Scan' },
    { id: 'is_hidden', name: 'Is Hidden' },
  ],
};

export function getActionLogReportAttributeChoices(
  entityTypes?: string[],
): { id: string; name: string }[] {
  const uniqueChoices = new Map<string, string>();
  const resolvedEntityTypes =
    entityTypes != null && entityTypes.length > 0
      ? entityTypes
      : ACTION_LOG_REPORT_ENTITY_CHOICES.map((choice) => choice.id);

  for (const entityType of resolvedEntityTypes) {
    for (const choice of attributeChoicesByEntityType[entityType] ?? []) {
      uniqueChoices.set(choice.id, choice.name);
    }
  }

  return [...uniqueChoices.entries()]
    .map(([id, name]) => ({ id, name }))
    .sort((left, right) => left.name.localeCompare(right.name));
}

export function formatActionLogReportDate(
  value?: string,
  dateFormat: string = supportedDateFormats[0].id,
): string {
  if (!value) {
    return '';
  }

  return DateTime.fromISO(value).toFormat(dateFormat);
}
